// 서버 상태 확인 간격 (1초(1000밀리초) * 숫자)
export const HEALTH_CHECK_INTERVAL_SECONDS = 1000 * 60 * 5; // 5분

// 메뉴 권한 부여 불가 항목
export const NOT_AVAILABLE_MENU_AUTH = ["/MenuMng", "/AuthApi", "/LogJob"];

// 작업(Service Broker Job) 데이터(현재 PID 및 Job 정보, LogJob) 갱신 간격
export const LOG_JOB_RELOAD_INTERVAL_SECONDS = 1000 * 60 * 1; // 1분
